import { ComponentType } from 'react';
import { Car } from '@lib/azgaz-ui/connect';
import { TBrandCar } from '@/selectors/getBrandCar';

export type Components = {
  CarTitle: ComponentType<{ car: Car }>;
  CarsItemPrice: ComponentType<{ car: NonNullable<TBrandCar> }>;
  CarsFilters: ComponentType<any>;
  DealerInfo: ComponentType<{ car: Car; className?: string, innerProps?: any }>;
};

const outsideComponents: Partial<Components> = {};

export default outsideComponents;
